import React, { useEffect, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
import { Plus, X } from "lucide-react";
import { apiFetch } from "../../api/api";
import { AxiosError } from "axios";

const Subjects = () => {
  const [subjects, setSubjects] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [showModal, setShowModal] = useState<boolean>(false);

  const [newSubject, setNewSubject] = useState({
    title: "",
  });

  // 📦 دریافت لیست موضوعات
  const fetchSubjects = async () => {
    try {
      setLoading(true);
      const res = await apiFetch({
        data: { params: [null, null, 4, 1, null] },
      });

      if (res.success && Array.isArray(res.rows)) {
        const formatted = res.rows.map((item: any) => ({
          id: item.SID,
          title: item.Title,
          status: item.Status?.data?.[0] ?? 0,
        }));
        setSubjects(formatted);
      } else {
        setError("خطا در دریافت اطلاعات موضوعات");
      }
    } catch (error) {
      const axiosError = error as AxiosError;
      setError(axiosError.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubjects();
  }, []);

  // 🔍 جستجو در موضوعات
  const handleSearch = (e: any) => {
    const search = e.target.value.toLowerCase();
    if (!search) return fetchSubjects();
    const filtered = subjects.filter((q) =>
      q.title.toLowerCase().includes(search)
    );
    setSubjects(filtered);
  };

  // ➕ افزودن موضوع جدید
  const handleAddSubject = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newSubject.title.trim()) return alert("عنوان موضوع را وارد کنید");

    try {
      setLoading(true);
      const res = await apiFetch({
        data: {
          params: [null, newSubject.title, 1, 1, null],
        },
      });

      if (res.success) {
        alert("موضوع با موفقیت ثبت شد ✅");
        setShowModal(false);
        setNewSubject({ title: "" });
        fetchSubjects();
      } else {
        alert("خطا در ثبت موضوع ❌");
      }
    } catch (error) {
      const axiosError = error as AxiosError;
      alert("خطا در ارتباط با سرور: " + axiosError.message);
    } finally {
      setLoading(false);
    }
  };

  // 🌀 وضعیت لودینگ
  if (loading)
    return (
      <div className="flex flex-col items-center justify-center min-h-[70vh]">
        <div className="w-12 h-12 border-4 border-custom-500 border-t-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-slate-600 dark:text-zink-200">
          در حال بارگذاری داده‌ها...
        </p>
      </div>
    );

  // ❌ خطا در دریافت داده‌ها
  if (error)
    return (
      <div className="flex flex-col items-center justify-center min-h-[70vh] text-red-500">
        <p>{error}</p>
        <button
          onClick={fetchSubjects}
          className="mt-3 btn bg-custom-500 text-white px-4 py-2 rounded-lg hover:bg-custom-600"
        >
          تلاش مجدد
        </button>
      </div>
    );

  return (
    <React.Fragment>
      <BreadCrumb title="لیست موضوعات" pageTitle="Subjects" />

      {/* 🔍 جستجو و افزودن */}
      <div className="grid grid-cols-1 gap-4 mb-5 lg:grid-cols-2">
        <div>
          <input
            type="text"
            placeholder="جستجو بر اساس عنوان..."
            onChange={handleSearch}
            className="form-input w-full border-slate-200 dark:border-zink-500 focus:border-custom-500 dark:focus:border-custom-800 dark:bg-zink-700"
          />
        </div>
        <div className="text-left lg:text-right">
          <button
            onClick={() => setShowModal(true)}
            className="text-white btn bg-custom-500 border-custom-500 hover:bg-custom-600"
          >
            <Plus className="inline-block size-4" /> <span>افزودن موضوع</span>
          </button>
        </div>
      </div>

      {/* 📋 جدول موضوعات */}
      <div className="card">
        <div className="card-body overflow-x-auto">
          {subjects && subjects.length > 0 ? (
            <table className="w-full whitespace-nowrap text-sm border border-slate-200 dark:border-zink-600">
              <thead className="bg-slate-100 dark:bg-zink-700 text-slate-600 dark:text-zink-200">
                <tr>
                  <th className="px-4 py-2 text-right">#</th>
                  <th className="px-4 py-2 text-right">عنوان موضوع</th>
               
                </tr>
              </thead>
              <tbody>
                {subjects.map((item, i) => (
                  <tr
                    key={item.id}
                    className="border-t border-slate-200 dark:border-zink-600 hover:bg-slate-50 dark:hover:bg-zink-800"
                  >
                    <td className="px-4 py-2">{i + 1}</td>
                    <td className="px-4 py-2">{item.title}</td>
                    
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="text-center text-slate-500 py-6">
              هیچ موضوعی یافت نشد.
            </p>
          )}
        </div>
      </div>

      {/* 🧩 مدال افزودن موضوع جدید */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
          <div className="bg-white dark:bg-zink-800 rounded-lg shadow-lg w-full max-w-md p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-slate-800 dark:text-zink-100">
                افزودن موضوع جدید
              </h3>
              <button onClick={() => setShowModal(false)}>
                <X className="text-slate-600 hover:text-red-500" />
              </button>
            </div>

            <form onSubmit={handleAddSubject} className="space-y-4">
              {/* عنوان موضوع */}
              <div>
                <label className="block text-sm mb-1">عنوان موضوع</label>
                <input
                  type="text"
                  value={newSubject.title}
                  onChange={(e) =>
                    setNewSubject({ ...newSubject, title: e.target.value })
                  }
                  className="form-input w-full border-slate-300 dark:bg-zink-700 dark:border-zink-600 focus:border-custom-500"
                  placeholder="مثلاً: درمانی"
                />
              </div>

              {/* دکمه‌ها */}
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="btn border border-slate-300 dark:border-zink-600 text-slate-600 hover:bg-slate-100"
                >
                  لغو
                </button>
                <button
                  type="submit"
                  className="btn bg-custom-500 text-white hover:bg-custom-600"
                >
                  ثبت موضوع
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Subjects;
